import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const ICONES = {
  dinheiro_entrada: { emoji:'🐷', label:'Cashin (entrada)' },
  vendas:           { emoji:'💰', label:'Vendas total' },
  criativos:        { emoji:'📸', label:'Criativos' },
  reunioes:         { emoji:'💻', label:'Reuniões' },
  qualificados:     { emoji:'📄', label:'Leads qualificados' },
  clientes:         { emoji:'🤝', label:'Novos clientes' },
  calls:            { emoji:'📞', label:'Calls realizadas' },
  proposta:         { emoji:'📋', label:'Propostas enviadas' },
};
const mesAtual = new Date().toLocaleString('pt-BR', { month:'long', year:'numeric' });
const corPorTipo = { dinheiro_entrada:'#5BAD8F', vendas:'#6B2FA0', criativos:'#D4789B', reunioes:'#4A90D9', qualificados:'#C9A84C', clientes:'#9B7FD4', calls:'#0891b2', proposta:'#d97706' };

export default function Metas() {
  const [metas, setMetas] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [modalAberto, setModalAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [filtroProj, setFiltroProj] = useState('');
  const [filtroColab, setFiltroColab] = useState('');
  const [form, setForm] = useState({ nome:'', tipo:'dinheiro_entrada', unidade:'R$', meta:'', atual:'', projeto:'Geral', colaborador:'Geral', periodo:mesAtual, recorrente:true });

  useEffect(() => { carregarDados(); }, []);

  async function carregarDados() {
    setCarregando(true);
    const [{ data: metasData }, { data: projData }, { data: colabData }] = await Promise.all([
      supabase.from('metas').select('*').order('created_at'),
      supabase.from('projetos').select('nome').order('nome'),
      supabase.from('colaboradores').select('nome').ilike('status', 'ativo').order('nome'),
    ]);
    if (metasData) setMetas(metasData);
    if (projData) setProjetos(['Geral', ...projData.map(p => p.nome)]);
    if (colabData) setColaboradores(['Geral', ...colabData.map(c => c.nome)]);
    setCarregando(false);
  }

  const metasFiltradas = metas.filter(m => {
    const projOk = !filtroProj || m.projeto === filtroProj || m.projeto === 'Geral';
    const colabOk = !filtroColab || m.colaborador === filtroColab || m.colaborador === 'Geral';
    return projOk && colabOk;
  });

  async function salvar() {
    if (!form.nome || !form.meta) return;
    const item = { ...form, meta: Number(form.meta), atual: Number(form.atual) };
    if (editando) {
      const { data } = await supabase.from('metas').update(item).eq('id', editando.id).select().single();
      if (data) setMetas(metas.map(m => m.id===editando.id?data:m));
    } else {
      const { data } = await supabase.from('metas').insert([item]).select().single();
      if (data) setMetas([...metas, data]);
    }
    setModalAberto(false); setEditando(null);
    setForm({ nome:'', tipo:'dinheiro_entrada', unidade:'R$', meta:'', atual:'', projeto:'Geral', colaborador:'Geral', periodo:mesAtual, recorrente:true });
  }

  async function atualizarValor(id, novoAtual) {
    const { data } = await supabase.from('metas').update({ atual: Number(novoAtual) }).eq('id', id).select().single();
    if (data) setMetas(metas.map(m => m.id===id?data:m));
  }

  function abrirEditar(meta) {
    setEditando(meta);
    setForm({ nome:meta.nome, tipo:meta.tipo, unidade:meta.unidade, meta:meta.meta, atual:meta.atual, projeto:meta.projeto, colaborador:meta.colaborador, periodo:meta.periodo, recorrente:meta.recorrente });
    setModalAberto(true);
  }

  const fmt = (m, v) => m.unidade==='R$' ? `R$ ${Number(v).toLocaleString('pt-BR')}` : Number(v).toLocaleString('pt-BR');
  const projetosComMetas = [...new Set(metasFiltradas.map(m => m.projeto))];

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando metas...</div>;

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Metas</h2><div className="section-line" /></div>

      <div className="filter-bar" style={{ marginBottom:20 }}>
        <select value={filtroProj} onChange={e => setFiltroProj(e.target.value)} className={`chip-select${filtroProj?' active':''}`}>
          <option value=''>Projeto</option>
          {projetos.map(p => <option key={p}>{p}</option>)}
        </select>
        <select value={filtroColab} onChange={e => setFiltroColab(e.target.value)} className={`chip-select${filtroColab?' active':''}`}>
          <option value=''>Colaborador</option>
          {colaboradores.map(c => <option key={c}>{c}</option>)}
        </select>
        {(filtroProj||filtroColab) && (
          <button onClick={() => { setFiltroProj(''); setFiltroColab(''); }} style={{ padding:'7px 12px', border:'none', borderRadius:10, background:'#F3EBFF', color:'#7B2FBE', cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'Poppins,sans-serif' }}>✕ Limpar</button>
        )}
        <div style={{ flex:1 }} />
        <button onClick={() => { setEditando(null); setForm({ nome:'', tipo:'dinheiro_entrada', unidade:'R$', meta:'', atual:'', projeto:'Geral', colaborador:'Geral', periodo:mesAtual, recorrente:true }); setModalAberto(true); }}
          style={{ background:'linear-gradient(135deg,#b45309,#D4AF37)', color:'white', border:'none', padding:'9px 22px', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Poppins,sans-serif', boxShadow:'0 4px 14px rgba(180,83,9,0.3)' }}>
          + Nova Meta
        </button>
      </div>

      {metasFiltradas.length === 0 && (
        <div className="card" style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>
          Nenhuma meta cadastrada. Clique em "+ Nova Meta" para começar!
        </div>
      )}

      {projetosComMetas.map(projeto => {
        const metasDoProjeto = metasFiltradas.filter(m => m.projeto===projeto);
        return (
          <div key={projeto} style={{ marginBottom:28 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
              <span style={{ fontWeight:700, fontSize:16, color:'var(--text-primary)' }}>{projeto}</span>
              <div style={{ flex:1, height:1, background:'var(--border)' }} />
              <span style={{ fontSize:12, color:'var(--gray-400)' }}>{metasDoProjeto.length} meta(s)</span>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16 }}>
              {metasDoProjeto.map(meta => {
                const pct = Math.min(100, Math.round((meta.atual/meta.meta)*100));
                const cor = corPorTipo[meta.tipo]||'var(--purple)';
                const icone = ICONES[meta.tipo];
                const bateu = pct>=100;
                return (
                  <div key={meta.id} className="card" style={{ padding:20, position:'relative', overflow:'hidden' }}>
                    <div style={{ position:'absolute', top:-10, right:-10, fontSize:64, opacity:0.06, userSelect:'none' }}>{icone?.emoji}</div>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 }}>
                      <div>
                        <div style={{ fontSize:24, marginBottom:4 }}>{icone?.emoji}</div>
                        <div style={{ fontWeight:700, fontSize:14, color:'var(--text-primary)', marginBottom:2 }}>{meta.nome}</div>
                        <div style={{ fontSize:11, color:'var(--gray-400)' }}>{icone?.label} · {meta.periodo}</div>
                        {meta.colaborador!=='Geral' && <div style={{ fontSize:11, color:'var(--purple)', fontWeight:600, marginTop:2 }}>👤 {meta.colaborador}</div>}
                      </div>
                      <div style={{ display:'flex', gap:6 }}>
                        {meta.recorrente && <span style={{ fontSize:10, color:'#4A90D9', background:'#EBF4FF', padding:'2px 7px', borderRadius:20, fontWeight:600 }}>Mensal</span>}
                        <button onClick={() => abrirEditar(meta)} style={{ background:'transparent', border:'1px solid var(--border)', padding:'3px 8px', borderRadius:5, cursor:'pointer', fontSize:11, color:'var(--text-secondary)' }}>Editar</button>
                      </div>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:10 }}>
                      <span style={{ fontSize:26, fontWeight:800, color:bateu?'#16a34a':cor }}>{fmt(meta,meta.atual)}</span>
                      <span style={{ fontSize:12, color:'var(--gray-400)' }}>de {fmt(meta,meta.meta)}</span>
                    </div>
                    <div style={{ background:'var(--border)', borderRadius:20, height:10, overflow:'hidden', marginBottom:8 }}>
                      <div style={{ width:`${pct}%`, height:'100%', background:bateu?'#16a34a':cor, borderRadius:20, transition:'width 0.4s' }} />
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                      <span style={{ fontSize:13, fontWeight:700, color:bateu?'#16a34a':pct>=70?cor:'#E05454' }}>{bateu?'🎉 Meta batida!':`${pct}%`}</span>
                      {!bateu && <span style={{ fontSize:11, color:'var(--gray-400)' }}>Faltam {fmt(meta,meta.meta-meta.atual)}</span>}
                    </div>
                    <div style={{ display:'flex', gap:6 }}>
                      <input type="number" defaultValue={meta.atual} onBlur={e => atualizarValor(meta.id, e.target.value)}
                        style={{ flex:1, padding:'6px 8px', border:'1px solid var(--border)', borderRadius:6, fontSize:12, background:'var(--bg-secondary)', color:'var(--text-primary)' }} />
                      <button onClick={e => atualizarValor(meta.id, e.currentTarget.previousSibling.value)}
                        style={{ background:cor, color:'white', border:'none', padding:'6px 10px', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:700 }}>✓</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {modalAberto && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div className="card" style={{ width:480, padding:32, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'var(--purple)' }}>{editando?'Editar Meta':'Nova Meta'}</h3>
              <button onClick={() => setModalAberto(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Ícone / Tipo</label>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:8 }}>
                {Object.entries(ICONES).map(([k,v]) => (
                  <div key={k} onClick={() => setForm({...form,tipo:k})}
                    style={{ padding:'10px 6px', borderRadius:8, border:`2px solid ${form.tipo===k?corPorTipo[k]:'var(--border)'}`, background:form.tipo===k?corPorTipo[k]+'22':'transparent', cursor:'pointer', textAlign:'center' }}>
                    <div style={{ fontSize:20 }}>{v.emoji}</div>
                    <div style={{ fontSize:9, color:form.tipo===k?corPorTipo[k]:'var(--gray-400)', marginTop:3, fontWeight:form.tipo===k?700:400 }}>{v.label}</div>
                  </div>
                ))}
              </div>
            </div>
            {[{label:'Nome da meta',key:'nome',type:'text'},{label:'Valor da meta',key:'meta',type:'number'},{label:'Valor atual',key:'atual',type:'number'},{label:'Período',key:'periodo',type:'text'}].map(f => (
              <div key={f.key} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                <input type={f.type} value={form[f.key]} onChange={e => setForm({...form,[f.key]:e.target.value})}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
              </div>
            ))}
            {[{label:'Unidade',key:'unidade',opts:['R$','un','%','min']},{label:'Projeto',key:'projeto',opts:projetos},{label:'Colaborador',key:'colaborador',opts:colaboradores}].map(f => (
              <div key={f.key} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                <select value={form[f.key]} onChange={e => setForm({...form,[f.key]:e.target.value})}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                  {f.opts.map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
            ))}
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                <input type="checkbox" checked={form.recorrente} onChange={e => setForm({...form,recorrente:e.target.checked})} />
                <span style={{ fontSize:13, color:'var(--text-secondary)' }}>🔄 Meta mensal recorrente</span>
              </label>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={salvar} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Salvar</button>
              <button onClick={() => setModalAberto(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
